import React from 'react';
import './ComplaintCheck.scss';

const ComplaintCheck = ({label,name,onChange,value,id}) => {

    return (
        <div className="col-xs-12 col-sm-12">
            <div className="col-xs-12 checkContainer">
                <label htmlFor={id}>{label}</label>
                <input type="checkbox" name={name} id={id} onChange={onChange} value={value} />
            </div>
        </div>
    );
}
    

export default ComplaintCheck;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/ComplaintCheck/ComplaintCheck.js